<template>
	<sa-page-layout :btnNewVisible="false" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :linkedit="linkedit" :linkback="linkback" :showModalLoading="showModalLoading">
		<template slot="table-filter">
			<b-form @submit.prevent="onSubmit">
				<b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
					<b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
						<label class="sa-label-data">Presidio:</label>
						<b-form-select v-model="filtroGestioneAmbulatoriale.idPresidio" :options="presidiOptions" :value="null" value-field="idPresidio" text-field="denominazionePresidio" @change="onChangePresidio" :disabled="true"></b-form-select>
					</b-col>
					<b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
						<label class="sa-label-data">Identificativo:</label>
						<b-form-input v-model="filtroGestioneAmbulatoriale.identificativo" type="search" id="identificativo" :placeholder="this.$i18n.t('adi.lblFiscalCode')"></b-form-input>
					</b-col>
					<b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
						<label class="sa-label-data">Cognome:</label>
						<b-form-input v-model="filtroGestioneAmbulatoriale.cognome" type="search" id="cognome" placeholder="Cognome"></b-form-input>
					</b-col>
					<b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
						<label class="sa-label-data">Nome:</label>
						<b-form-input v-model="filtroGestioneAmbulatoriale.nome" type="search" id="nome" placeholder="Nome"></b-form-input>
					</b-col>
				</b-row>
				<b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
					<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
						<b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
						<b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
					</b-col>
				</b-row>
			</b-form>
		</template>
		<template slot="table-body">
			<rsa-gestione-ospiti-list-component regime="AMBULATORIALE" pathResource="/rsaospiti/ambulatoriali" ref="RsaGestioneOspitiListComponent" @afterLoadData="onAfterLoadData"></rsa-gestione-ospiti-list-component>
		</template>
	</sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaGestioneOspitiListComponent from "../../rsagestioneospiti/components/RsaGestioneOspitiListComponent.vue";
import PresidiMixin from "../../../strutture/mixins/PresidiMixin";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
	mixins: [UtilityMixin, PresidiMixin],
	components: { SaPageLayout, RsaGestioneOspitiListComponent },
	data() {
		return {
			pathResource: null,
			linkedit: null,
			linkback: null,
			showModalLoading: false,
			presidiOptions: [],
			idPresidio: null,
			filtroGestioneAmbulatoriale: { nome: null, cognome: null, identificativo: null, idPresidio: null },
		};
	},
	mounted() {
		let me = this;
		let sessionStorage = window.sessionStorage;
		if (sessionStorage.getItem("filtroGestioneAmbulatoriale")) {
			me.filtroGestioneOspiti = JSON.parse(sessionStorage["filtroGestioneOspiti"]);
		}
		if (localStorage.getItem("presidio")) {
			me.presidio = localStorage.getItem("presidio") == "null" ? null : JSON.parse(localStorage.getItem("presidio"));
			me.idPresidio = me.presidio ? me.presidio.idPresidio : null;
			me.filtroGestioneAmbulatoriale.idPresidio = me.idPresidio;
		}
		console.log(me.idPresidio);
	},
	methods: {
		loadData() {
			let me = this;
			me.showModalLoading = true;
			let sessionStorage = window.sessionStorage;
			sessionStorage["filtroGestioneAmbulatoriale"] = JSON.stringify(me.filtroGestioneAmbulatoriale);
			me.$refs.RsaGestioneOspitiListComponent.loadData(me.filtroGestioneAmbulatoriale);
		},
		localAfterLoadPresidiUtente() {
			console.log("OK");
			this.loadData(this.filtroGestioneAmbulatoriale);
		},
		onRefresh() {
			this.loadData();
		},
		onChangePresidio() {},
		onReset() {
			let me = this;
			me.filtroGestioneOspiti = { nome: null, cognome: null, identificativo: null, idPresidio: me.idPresidio };
			let sessionStorage = window.sessionStorage;
			sessionStorage["filtroGestioneAmbulatoriale"] = JSON.stringify(me.filtroGestioneOspiti);
			if (me.idPresidio) {
				me.loadSettingsPresidi(me.idPresidio);
			}
		},
		onAfterLoadData() {
			this.showModalLoading = false;
		},
		onSubmit() {
			let me = this;
			// let sessionStorage = window.sessionStorage;
			// sessionStorage["filtroGestioneAmbulatoriale"] = JSON.stringify(me.filtroGestioneOspiti);
			// let sessionStorage = window.sessionStorage;
			// if (sessionStorage["filtroGestioneOspiti"]) {
			// 	me.filtroGestioneOspiti = JSON.parse(sessionStorage["filtroGestioneOspiti"]);
			// }
			me.loadData(me.filtroGestioneAmbulatoriale);
		},
	},
};
</script>

<style></style>
